<template>
    <!-- 场地路由 -->
    <div>
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    
}
</script>
